<style scoped>

	.fade-enter-active,
	.fade-leave-active {
		transition-duration: 0.3s;
		transition-property: opacity;
		transition-timing-function: ease;
	}

	.fade-enter,
	.fade-leave-active {
		opacity: 0;
	}

	#mainWrap {
		max-width: 380px;
	}

</style>

<template>

	<v-container fluid class="px-0 py-0 my-0" id="mainWrap">
		<!-- <sidebar v-if="login" /> -->
		<transition name="fade" mode="out-in">
			<router-view v-if="login" id="main" :locale="locale" :dir="dir"></router-view>
			<router-view v-if="!login" id="main" class="mt-5" :locale="locale"></router-view>
		</transition>
		<snackbar v-if="login" />
	</v-container>

</template>

<script>

	import Sidebar from './App_Parts/sidebar';
	import Snackbar from './App_Parts/snackbar';
	import { mapGetters } from 'vuex';
	export default {
		components: { Sidebar, Snackbar },
		data() {
			return {
				login: Auth.logged(),
				locale: Lang.get(),
				dir: '',
				items: null,
				listening: false,
				key: 0,
				gone: 0,
				presentInterval: null
			};
		},
		created() {
			this.dir = this.locale == 'he' ? 'rtl' : 'ltr';
		},
		mounted() {
			this.$nextTick(function() {
				window.addEventListener('blur', this.leftpage);
				window.addEventListener('focus', this.cameback);
			});
		},
		watch: {
		},
		methods: {
			leftpage() {
				this.presentInterval = setInterval(() => {
					this.gone++;
				}, 1000);
			},
			cameback() {
				clearInterval(this.presentInterval);
				this.gone = 0;
			},
		}
	};

</script>
